// Shared Cloudinary widget configuration and factory function
export const CLOUDINARY_TEXT_CONFIG = {
  he: {
    or: 'אוֹ',
    menu: {
      files: 'תמונה',
    },
    queue: {
      upload_more: 'העלה עוד',
      done: 'בוצע',
    },
    camera: {
      capture: 'Capture',
      cancel: 'Cancel',
      take_pic: 'Take a picture and upload it',
      explanation:
        'Make sure that your camera is connected and that your browser allows camera capture. When ready, click Capture.',
      camera_error: 'Failed to access camera',
      retry: 'Retry Camera',
      file_name: 'Camera_{{time}}',
    },
    dropbox: {
      no_auth_title: 'Upload files from your Dropbox account.',
      no_auth_action: 'Connect to Dropbox',
      no_photos: 'No Photos',
      no_files: 'No Files',
      root_crumb: 'Root',
      list_headers: {
        select: 'Select',
        name: 'Name',
        modified: 'Modified',
      },
      menu: {
        browse: 'Browse',
        recent: 'Recent',
      },
      authenticating: 'Authenticating...',
    },
    google_drive: {
      no_auth_title: 'Upload files from your Google Drive.',
      no_auth_action: 'Connect to Google Drive',
      search: {
        placeholder: 'Search...',
        reset: 'Reset search',
      },
      grid: {
        folders: 'Folders',
        files: 'Image',
        empty_folder: 'This folder is empty.',
      },
      recent: 'Recent',
      starred: 'Starred',
      my_drive: 'My Drive',
      shared_drive: 'Shared drives',
      search_results: 'Search results',
      shared_with_me: 'Shared with me',
      name: 'Name',
      modifiedTime: 'Last modified',
      modifiedByMeTime: 'Last modified by me',
      viewedByMeTime: 'Last opened by me',
      notifications: {
        retrieve_failed:
          'Failed to retrieve upload data from Google Drive.',
      },
    },
    local: {
      browse: 'לְדַפדֵף',
      dd_title_single: 'Drag and Drop an asset here',
      dd_title_multi: 'גרור ושחרר נכסים כאן',
      drop_title_single: 'Drop a file to upload',
      drop_title_multiple: 'Drop files to upload',
    },
  },
  ar: {
    or: 'أو',
    menu: {
      files: 'ملفاتي',
    },
    queue: {
      upload_more: 'تحميل المزيد',
      done: 'فعله',
    },
    camera: {
      capture: 'Capture',
      cancel: 'Cancel',
      take_pic: 'Take a picture and upload it',
      explanation:
        'Make sure that your camera is connected and that your browser allows camera capture. When ready, click Capture.',
      camera_error: 'Failed to access camera',
      retry: 'Retry Camera',
      file_name: 'Camera_{{time}}',
    },
    dropbox: {
      no_auth_title: 'Upload files from your Dropbox account.',
      no_auth_action: 'Connect to Dropbox',
      no_photos: 'No Photos',
      no_files: 'No Files',
      root_crumb: 'Root',
      list_headers: {
        select: 'Select',
        name: 'Name',
        modified: 'Modified',
      },
      menu: {
        browse: 'Browse',
        recent: 'Recent',
      },
      authenticating: 'Authenticating...',
    },
    google_drive: {
      no_auth_title: 'Upload files from your Google Drive.',
      no_auth_action: 'Connect to Google Drive',
      search: {
        placeholder: 'Search...',
        reset: 'Reset search',
      },
      grid: {
        folders: 'Folders',
        files: 'Files',
        empty_folder: 'This folder is empty.',
      },
      recent: 'Recent',
      starred: 'Starred',
      my_drive: 'My Drive',
      shared_drive: 'Shared drives',
      search_results: 'Search results',
      shared_with_me: 'Shared with me',
      name: 'Name',
      modifiedTime: 'Last modified',
      modifiedByMeTime: 'Last modified by me',
      viewedByMeTime: 'Last opened by me',
      notifications: {
        retrieve_failed:
          'Failed to retrieve upload data from Google Drive.',
      },
    },
    local: {
      browse: 'تصفح',
      dd_title_single: 'Drag and Drop an asset here',
      dd_title_multi: 'اسحب الأصول وأفلتها هنا',
      drop_title_single: 'Drop a file to upload',
      drop_title_multiple: 'Drop files to upload',
    },
  },
};

export const BASE_CLOUDINARY_CONFIG = {
  cloudName: 'tidp',
  uploadPreset: 'fz7jch0p',
  sources: ['local', 'dropbox', 'google_drive'], // removed 'camera' as it is lame on desktop and not needed on mobile since we have the camera capture button
  clientAllowedFormats: ["png", "jpg", "jpeg"],
  cropping: true,
  croppingAspectRatio: 1.5,
  showSkipCropButton: false,
  resourceType: 'image',
  minImageWidth: '700',
  maxImageWidth: '2000',
  minImageHeight: '500',
  maxImageHeight: '1500',
  text: CLOUDINARY_TEXT_CONFIG,
};

/**
 * Creates a Cloudinary upload widget with the provided options.
 * @param {Object} options - Configuration options
 * @param {string} options.language - Language code (e.g., 'en', 'he', 'ar')
 * @param {string} options.folder - Upload folder
 * @param {Function} options.callback - Full callback function for widget events
 * @returns {Object} Cloudinary widget instance
 */
export function createCloudinaryWidget({ language, folder, callback }) {
  const config = {
    ...BASE_CLOUDINARY_CONFIG,
    language,
    folder,
  };

  return window.cloudinary.createUploadWidget(config, callback);
}